module.exports = __webpack_public_path__ + "img/icon-info.23a4feb0.svg";